import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/lib/api-client";
import { normalizeCatalogTree, type CatalogNode } from "@/lib/catalog-tree";
import type { CatalogResponse } from "@/types/api";

export interface NormalizedCatalog {
  categories: CatalogNode[];
}

/**
 * The single normalization seam: every consumer sees `CatalogNode`s with a guaranteed
 * `children` array, whether the backend sends the recursive `children` field or the
 * deprecated two-level `subcategories` one.
 */
export const catalogQueryOptions = {
  queryKey: ["catalog"] as const,
  queryFn: () => apiClient.get<CatalogResponse>("/catalog"),
  select: (raw: CatalogResponse): NormalizedCatalog => ({
    categories: normalizeCatalogTree(raw.categories),
  }),
};

export const useCatalog = (options?: { enabled?: boolean }) =>
  useQuery<CatalogResponse, Error, NormalizedCatalog>({
    ...catalogQueryOptions,
    enabled: options?.enabled ?? true,
  });
